/**
 * ==========================================================================
 * JHC Commerce Framework
 * Matcha Guide
 * --------------------------------------------------------------------------
 * - Scroll reveal for the header and step rows (scoped to .jhc-guide)
 * ==========================================================================
 */

(function () {
  'use strict';

  function initReveal(root) {
    if (!root) return;

    var revealEls = root.querySelectorAll('.jhc-reveal');
    if (!revealEls.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  document.querySelectorAll('.jhc-guide').forEach(initReveal);

  // Re-init when the section is added/updated in the Theme Editor
  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target.querySelector('.jhc-guide'));
  });
})();